import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);
 
const ShelfDialog = ({ open, onClose, onSave, shelfData, isEdit }) => {
  const [description, setDescription] = useState("");
  const [interval, setInterval] = useState(4);
  const [nextDue, setNextDue] = useState(dayjs());
  const [active, setActive] = useState(true);
  const [pharmacyId, setPharmacyId] = useState("");
  const [pharmacies, setPharmacies] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("members") || "[]");
    setPharmacies(stored);

    if (isEdit && shelfData) {
      setDescription(shelfData.description || "");
      setInterval(shelfData.interval || 4);
      setNextDue(dayjs(shelfData.nextdue));
      setActive(!!shelfData.active);
      setPharmacyId(shelfData.pharmacyId || "");
    } else {
      setDescription("");
      setInterval(4);
      setNextDue(dayjs());
      setActive(true);
      setPharmacyId("");
    }
  }, [shelfData, isEdit]);

const handleSave = () => {
  if (!description || !interval || !nextDue || !pharmacyId) {
    alert("Please complete all fields including pharmacy.");
    return;
  }

  const selectedPharmacy = pharmacies.find(p => p.pharmacyId === pharmacyId);
  if (!selectedPharmacy) {
    alert("Invalid pharmacy selected.");
    return;
  }

  const newData = {
    description,
    interval,
    nextdue: nextDue.toISOString(),
    active,
    pharmacyId: selectedPharmacy.pharmacyId,
    pharmacyName: selectedPharmacy.pharmacyName,
  };

  onSave(newData);
};

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{isEdit ? "Edit Shelf" : "Add Shelf"}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>Pharmacy</InputLabel>
          <Select
            value={pharmacyId}
            label="Pharmacy"
            onChange={(e) => setPharmacyId(e.target.value)}
          >
            {pharmacies.map((pharmacy) => (
              <MenuItem key={pharmacy.pharmacyId} value={pharmacy.pharmacyId}>
                {pharmacy.pharmacyName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Shelf Name"
          fullWidth
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Interval (weeks)"
          type="number"
          fullWidth
          value={interval}
          onChange={(e) => setInterval(parseInt(e.target.value) || 0)}
          margin="normal"
        />
        <DatePicker
          label="Next Due Date"
          value={nextDue}
          onChange={(newVal) => setNextDue(newVal)}
          format="DD/MM/YY"
          sx={{ width: '100%', marginTop: 2 }}
        />
        {isEdit && (
          <FormControlLabel
            control={<Checkbox checked={active} onChange={(e) => setActive(e.target.checked)} />}
            label="Active"
            sx={{ marginTop: 2 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShelfDialog;
